export default __webpack_public_path__ + "static/bma-71907287edebe72cb80a5ba9372be13f.jpg";